import axios from "axios";

export const getOutboundFeeds = (clientId) => {
  return axios
    .get(import.meta.env.VITE_BACKEND_API + "/api/OutboundFeeds/getFeeds/" + clientId)
    .then((res) => res.data);
};

export const getStates = (countryId) => {
  return axios
    .get(import.meta.env.VITE_BACKEND_API + "/api/OutboundFeeds/getStates/" + countryId)
    .then((res) => res.data);
};

export const getAllFeedOptions = (clientId) => {
  return axios
    .get(import.meta.env.VITE_BACKEND_API + "/api/OutboundFeeds/getAllFeedOptions/" + clientId)
    .then((res) => res.data);
};

export const addFeed = (newFeed) => {
  return axios
    .post(import.meta.env.VITE_BACKEND_API + "/api/OutboundFeeds/addFeed", newFeed, {
      headers: {
        "Content-Type": "application/json",
        client: newFeed.ClientId,
      },
    })
    .then((res) => res.data);
};

export const editOutboundFeed = (editedFeed) => {
  return axios
    .put(import.meta.env.VITE_BACKEND_API + "/api/OutboundFeeds/editFeed/", editedFeed, {
      headers: {
        "Content-Type": "application/json",
        client: editedFeed.ClientId,
      },
    })
    .then((res) => res.data);
};

export const deleteOutboundFeed = (feedId, clientId) => {
  return axios
    .delete(import.meta.env.VITE_BACKEND_API + "/api/OutboundFeeds/deleteFeed/" + feedId, {
      headers: {
        "Content-Type": "application/json",
        client: clientId,
      },
    })
    .then((res) => res.data);
};
